import React from 'react'
import { List } from 'immutable'
import { calculateProgressBarValues } from '../utils'

/**
   * Course detail page progress bar component
 * @param {Object} props - The props
 * @param {List} props.modulesData - The course modules data
 * @param {Map} props.progressData - The course progress data
 * @param {Map} props.hintText - The hint text data
 * @param {Boolean} props.showTotalProgress - Whether to show the total progress
 * @returns {JSX.Element} DetailPageV3CourseProgressBar
 */

const DetailPageV3CourseProgressBar = (props) => {
  const {
    modulesData = List(),
    progressData = Map(),
    hintText,
    showTotalProgress = false,
  } = props

  const totalProgress = progressData.getIn(['metrics', 'percentageItemsComplete'], 0) || 0
  const progressBarValues = calculateProgressBarValues(modulesData)

  return (
    <div className="detail-page-v3__course-progress-bar-container">
      {showTotalProgress && (
        <div className="detail-page-v3__course-progress-bar-hint">
          {hintText}<span>{Math.round(totalProgress)}%</span>
        </div>
      )}
      <div className="detail-page-v3__course-progress-bar">
        {progressBarValues.map((moduleProgress, index) => (
          <div key={index} className="detail-page-v3__course-progress-bar-segment">
            <div className="detail-page-v3__course-progress-bar-segment-progress" style={{ width: `${moduleProgress}%` }}></div>
          </div>
        ))}
        <div className="detail-page-v3__course-progress-bar-progress"></div>
      </div>
    </div>
  )
}

export default DetailPageV3CourseProgressBar
